export const DeterminationReasonsShow = {
  ZS03: "ZS03",
  ZS01: "ZS01",
  ZS02: "ZS02",
  ZS05: "ZS05",
};

export const TerminationTypeIsECE = "1";
export const TerminationTypeCustomer = "2";
export const TerminationTypeNotShow = "3";

export const ProcessReason = {
  1: "01",
  2: "02",
  3: "03",
};

export const ProcessReasonsShow = Object.values(ProcessReason);

export interface IContractTypes {
  contractsTypePN: string;
  contractsTypeNN: string;
  contractsTypeN: string;
}

export const ContractTypes: IContractTypes = {
  contractsTypePN: "PN",
  contractsTypeNN: "NN",
  contractsTypeN: "N",
};

export const DefaultNoticeUnit = "M";
export const DistributorIdCEZ = "ED-CEZ";
export interface IPreviousCustomers {
  household: string;
  business: string;
}

export const PreviousCustomers: IPreviousCustomers = {
  household: "household",
  business: "business",
};
